import config from 'constants/config'
import themes from 'constants/themes'
// oxlint-disable-next-line no-restricted-imports - Imported to support rebrand theme selection
import { luxuryEscapesRebrandTheme } from 'constants/themes/luxuryescapesRebrand'

export type RebrandVersion = 'legacy' | 'rebrand'
export const REBRAND_PALETTE_CLASS = 'app-palette-rebrand'

function supportsRebrand(brand: string): boolean {
  return brand === 'luxuryescapes' || brand === 'leagenthub'
}

/** Shared by SSR and the client; brand design does not depend on tracking consent. */
export function getRebrandVersion(
  brandConfig: Pick<App.AppConfig, 'BRAND' | 'REBRAND_ENABLED'> = config,
): RebrandVersion {
  return supportsRebrand(brandConfig.BRAND) && brandConfig.REBRAND_ENABLED
    ? 'rebrand'
    : 'legacy'
}

export function getBrandTheme(brand: string, version: RebrandVersion): App.Design.Theme {
  if (supportsRebrand(brand) && version === 'rebrand') {
    return luxuryEscapesRebrandTheme
  }

  return themes[brand] ?? themes.luxuryescapes
}
